const fundingItems = [
  {
    icon: 'ri-shirt-line',
    title: 'Gameday Jerseys',
    dollarRange: '$15,000',
    description: 'Custom game-day jerseys for every player on the roster, printed with your logo on the sleeve.',
    color: 'bg-yellow-50 border-yellow-200',
    iconBg: 'bg-yellow-100',
    iconColor: 'text-yellow-700',
  },
  {
    icon: 'ri-landscape-line',
    title: 'Field Rental & CYFA Dues',
    dollarRange: '$30,000',
    description: 'Covers field rental costs and annual CYFA league dues so every home and away game can be played.',
    color: 'bg-purple-50 border-purple-200',
    iconBg: 'bg-purple-100',
    iconColor: 'text-purple-700',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Game Day Officials',
    dollarRange: '$21,000',
    description: 'Pays for certified officials across all games — ensuring fair, safe, and professional play.',
    color: 'bg-yellow-50 border-yellow-200',
    iconBg: 'bg-yellow-100',
    iconColor: 'text-yellow-700',
  },
  {
    icon: 'ri-whistle-line',
    title: 'Coach & Player Training',
    dollarRange: '$20,000',
    description: 'Funds coaching clinics, player development programs, and training resources throughout the season.',
    color: 'bg-purple-50 border-purple-200',
    iconBg: 'bg-purple-100',
    iconColor: 'text-purple-700',
  },
  {
    icon: 'ri-football-line',
    title: 'Equipment',
    dollarRange: '$14,000',
    description: 'Supplies helmets, pads, blocking sleds, agility ladders, cones, and footballs used every practice.',
    color: 'bg-yellow-50 border-yellow-200',
    iconBg: 'bg-yellow-100',
    iconColor: 'text-yellow-700',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Admin, Insurance & Fees',
    dollarRange: '$8,000',
    description: 'Covers administrative costs, player insurance, and website transaction fees that keep the league running.',
    color: 'bg-purple-50 border-purple-200',
    iconBg: 'bg-purple-100',
    iconColor: 'text-purple-700',
  },
  {
    icon: 'ri-hand-heart-line',
    title: 'Player Financial Assistance',
    dollarRange: '$10,000',
    description: 'Ensures no player is left out due to financial hardship — every kid who wants to play gets to play.',
    color: 'bg-yellow-50 border-yellow-200',
    iconBg: 'bg-yellow-100',
    iconColor: 'text-yellow-700',
  },
];

export default function SponsorshipFunds() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block bg-yellow-100 text-yellow-800 text-sm font-bold uppercase tracking-widest px-4 py-2 rounded-full mb-4">
            Your Dollars At Work
          </span>
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-6">
            What Your Sponsorship <span className="text-purple-700">Actually Funds</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Every dollar goes directly to the kids. Here's exactly what your investment pays for — no guessing, no fluff.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {fundingItems.map((item, index) => (
            <div
              key={index}
              className={`border-2 rounded-2xl p-6 flex flex-col gap-4 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 ${item.color}`}
            >
              <div className="flex items-start gap-2">
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl flex-shrink-0 ${item.iconBg}`}>
                  <i className={`${item.icon} text-2xl ${item.iconColor}`}></i>
                </div>
              </div>

              <div>
                <h3 className="text-xl font-black text-gray-900 mb-1">{item.title}</h3>
                <p className="text-3xl font-black text-purple-700 mb-3">{item.dollarRange}</p>
                <p className="text-sm text-gray-600 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom callout */}
        <div className="bg-purple-900 rounded-3xl p-10 md:p-14 text-white text-center">
          <div className="w-16 h-16 flex items-center justify-center bg-yellow-400 rounded-full mx-auto mb-6">
            <i className="ri-heart-fill text-3xl text-purple-900"></i>
          </div>
          <h3 className="text-3xl md:text-4xl font-black mb-4">
            100% Goes Back to the Kids
          </h3>
          <p className="text-lg text-purple-200 max-w-2xl mx-auto leading-relaxed mb-8">
            CYFA is a volunteer-run, nonprofit organization. There are no salaries, no overhead bloat — every sponsorship dollar is reinvested directly into equipment, facilities, and experiences for Caledonia youth.
          </p>
          <div className="flex flex-wrap justify-center gap-6 text-sm font-bold text-yellow-300">
            <span className="flex items-center gap-2">
              <i className="ri-check-double-line text-lg"></i> Volunteer-run organization
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-check-double-line text-lg"></i> Nonprofit status
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-check-double-line text-lg"></i> Full financial transparency
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
